import { useLocation } from 'react-router-dom'
import { useState } from 'react'
import SafeltoLogo from '../SafeltoLogo'
import SideNavItem from '../SideNavItem'
import { extraSideNavItems, logoutSideNavItem, mainSideNavItems } from './sidebarData'
import logout from '../../utils/logout'
import LogoutModal from './logout'

interface SideNavProps {
  collapsed: boolean
  toggle: () => void
}

const SideNav = ({ collapsed, toggle }: SideNavProps) => {
  const location = useLocation()
  const [showLogoutModal, setShowLogoutModal] = useState(false)

  const handleLogoutClick = () => {
    setShowLogoutModal(true)
  }

  const confirmLogout = () => {
    setShowLogoutModal(false)
    logout()
  }

  const cancelLogout = () => {
    setShowLogoutModal(false)
  }

  const isActive = (path: string) => {
    const main = location.pathname.split('/')
    return main[1] === path.split('/')[0]
  }

  const filteredMainSideNavItems = mainSideNavItems.filter(
    (item) => item.title !== 'Wallet'
  )
  const filteredExtraSideNavItems = extraSideNavItems.filter(
    (item) => item.title !== 'Property Listing'
  )

  return (
    <section
      className={`h-full ${
        collapsed ? 'w-[70px]' : 'w-[260px] px-4'
      } fixed transition-all duration-500 px-2 py-5 bg-gray-100 overflow-x-hidden no-scrollbar font-face-worksans`}
      style={{ zIndex: 998 }}
    >
      <div className="space-y-6">
        <div>
          <SafeltoLogo theme="dark" displayText={!collapsed} />
        </div>
        <div>
          <div className="text-right" onClick={toggle}>
            <button className="w-fit px-2 rounded text-gray-500">
              {collapsed ? '>>>>' : '<<<<'}
            </button>
          </div>
          {filteredMainSideNavItems.map((item) => (
            <SideNavItem
              key={item.title}
              title={item.title}
              icon={item.icon}
              isActive={isActive(item.path)}
              path={item.path}
              onClick={item.onClick}
              permissions={item.permissions}
            />
          ))}
        </div>
        <div>
          <p className="text-center">More</p>
          {filteredExtraSideNavItems.map((item) => (
            <SideNavItem
              key={item.title}
              title={item.title}
              icon={item.icon}
              isActive={isActive(item.path)}
              path={item.path}
              onClick={item.onClick}
            />
          ))}
        </div>
        <div>
          <SideNavItem
            title={logoutSideNavItem.title}
            icon={logoutSideNavItem.icon}
            isActive={false}
            path={''}
            onClick={handleLogoutClick}
          />
        </div>
      </div>

      <LogoutModal
        isOpen={showLogoutModal}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </section>
  )
}

export default SideNav
